import { defineIntegration, applyAggregateErrorsToEvent } from '@sentry/core';
import { exceptionFromError } from '../eventbuilder.js';
var DEFAULT_KEY = 'cause';
var DEFAULT_LIMIT = 5;
var INTEGRATION_NAME = 'LinkedErrors';

var _linkedErrorsIntegration = function _linkedErrorsIntegration() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var limit = options.limit || DEFAULT_LIMIT;
  var key = options.key || DEFAULT_KEY;
  return {
    name: INTEGRATION_NAME,

    preprocessEvent(event, hint, client) {
      var options = client.getOptions();
      applyAggregateErrorsToEvent( // This differs from the LinkedErrors integration in core by using a different exceptionFromError function
      exceptionFromError, options.stackParser, options.maxValueLength, key, limit, event, hint);
    }

  };
};
/**
 * Aggregrate linked errors in an event.
 */


var linkedErrorsIntegration = defineIntegration(_linkedErrorsIntegration);
export { linkedErrorsIntegration };